import { z } from "zod";
import { commercialConditionPricingModel, commercialConditionStatus, commercialConditionType } from "~/supabase.values";
import { buildTypeIssueMessage, required } from "../shared";

export const schemaCommercialConditionCreate = z.object({
  business_unit_id: z.string({ error: buildTypeIssueMessage({ whenMissing: required("La business unit") }) }),
  company_id: z.string({ error: buildTypeIssueMessage({ whenMissing: required("La société / l'agence") }) }),
  company_name: z.string({ error: buildTypeIssueMessage({ whenMissing: required("Le nom de l'entreprise") }) }),
  company_address: z.string({ error: buildTypeIssueMessage({ whenMissing: required("La société / l'agence") }) }),
  type: z.enum(commercialConditionType, { error: buildTypeIssueMessage({ whenMissing: required("Le statut") }) }),
  guarantees: z.string({ error: buildTypeIssueMessage({ whenMissing: required("Les garanties") }) }),
  pricing: z.string({ error: buildTypeIssueMessage({ whenMissing: required("Le prix") }) }),
  pricing_model: z.enum(commercialConditionPricingModel, {
    error: buildTypeIssueMessage({ whenMissing: required("Le statut") }),
  }),
  payment_terms: z.string({ error: buildTypeIssueMessage({ whenMissing: required("Les conditions de paiement") }) }),
  payment_method: z.string({ error: buildTypeIssueMessage({ whenMissing: required("Le moyen de paiement") }) }),
  signatory_name: z.string({ error: buildTypeIssueMessage({ whenMissing: required("Le signataire") }) }),
  signatory_job_title: z.string({ error: buildTypeIssueMessage({ whenMissing: required("Le poste du signataire") }) }),
  signatory_city: z.string({ error: buildTypeIssueMessage({ whenMissing: required("La ville du signataire") }) }),
  status: z.enum(commercialConditionStatus, { error: buildTypeIssueMessage({ whenMissing: required("Le statut") }) }),
});
